import { BoxProps } from "@shopify/restyle";
import React from "react";

import { Theme } from "../../../../theme/restyle/theme";
import { Box } from "../../../primitive";

type PanelHeaderChildWrapperProps = BoxProps<Theme> & {
  children: React.ReactNode;
};

export const PanelHeaderChildWrapper = ({
  children,
  ...rest
}: PanelHeaderChildWrapperProps) => {
  return (
    <Box
      position="absolute"
      width={48}
      height={48}
      justifyContent="center"
      alignItems="center"
      zIndex={10}
      {...rest}
    >
      {children}
    </Box>
  );
};
